import {
  ControlledTooltip,
  ControlledTooltipBody,
  ControlledTooltipTitle,
} from 'components/DtiRadialMeter/ControlledTooltip'

export const TooltipMonthlyExpenses = () => {
  const componentTitle = (
    <ControlledTooltipTitle>Monthly debt & expenses (estimated)</ControlledTooltipTitle>
  )

  const componentBody = (
    <ControlledTooltipBody>
      <>
        <p>
          {`Don't include expenses like utility bills, food, and entertainment for
          more accurate results.`}
        </p>
        <p>Add up all your monthly debt payments and expenses from:</p>
        <ul>
          <li>credit cards</li>
          <li>auto loans</li>
          <li>personal loans</li>
          <li>student loans</li>
          <li>mortgage/rent</li>
          <li>home insurance</li>
          <li>property tax</li>
          <li>HOA fees</li>
          <li>other loans & expenses (child support, alimony, etc.)</li>
        </ul>
      </>
    </ControlledTooltipBody>
  )

  return <ControlledTooltip modalTitle={componentTitle} modalBody={componentBody} />
}
